module.exports = __webpack_public_path__ + "static/img/online_card.663ea6f4.png";